module.exports = __webpack_public_path__ + "img/tema-3-6.5a2b5b30.gif";